import * as actions from 'actions'
import get from 'lodash/get'

export default function reducer(
  state = {
    register: {
      fetching: false,
      error: null,
      data: {},
    },
    finishWebAuthNRegistration: {
      fetching: false,
      data: {},
    },
    mfaRegisteredDevices: {
      fetching: false,
      error: null,
      data: [],
    },
    deleteMFADevice: {
      fetching: false,
      error: null,
    },
    deleteAllMFADevice: {
      fetching: false,
      error: null,
    },
    initiateAuthentication: {
      fetching: false,
      error: null,
      data: {},
    },
  },
  action
) {
  switch (action.type) {
    case `${actions.START_USER_WEBAUTHN_REGISTER}_PENDING`: {
      return {
        ...state,
        register: {
          fetching: true,
          error: null,
          data: {},
        },
      }
    }

    case `${actions.START_USER_WEBAUTHN_REGISTER}_FULFILLED`: {
      const data = get(action, 'payload.data', {})

      return {
        ...state,
        register: {
          fetching: false,
          error: null,
          data,
        },
      }
    }

    case `${actions.START_USER_WEBAUTHN_REGISTER}_REJECTED`: {
      return {
        ...state,
        register: {
          fetching: false,
          error: 'Something went wrong during MFA device registration.',
          data: {},
        },
      }
    }

    case `${actions.GET_USER_MFA_REGISTERATIONS_FOR_ADMIN}_PENDING`: {
      return {
        ...state,
        mfaRegisteredDevices: {
          fetching: true,
          error: null,
          data: [],
        },
      }
    }

    case `${actions.GET_USER_MFA_REGISTERATIONS_FOR_ADMIN}_FULFILLED`: {
      const data = get(action, 'payload.data', {})

      return {
        ...state,
        mfaRegisteredDevices: {
          fetching: false,
          error: null,
          data,
        },
      }
    }

    case `${actions.GET_USER_MFA_REGISTERATIONS_FOR_ADMIN}_REJECTED`: {
      return {
        ...state,
        mfaRegisteredDevices: {
          fetching: false,
          error: 'Something went wrong during MFA device registration.',
          data: [],
        },
      }
    }

    case `${actions.FINISH_USER_WEBAUTHN_REGISTER}_PENDING`: {
      return {
        ...state,
        finishWebAuthNRegistration: {
          fetching: true,
          data: {},
        },
      }
    }

    case `${actions.FINISH_USER_WEBAUTHN_REGISTER}_FULFILLED`: {
      const data = get(action, 'payload.data', {})
      return {
        ...state,
        finishWebAuthNRegistration: {
          fetching: false,
          data,
        },
      }
    }

    case `${actions.FINISH_USER_WEBAUTHN_REGISTER}_REJECTED`: {
      return {
        ...state,
        finishWebAuthNRegistration: {
          fetching: false,
          data: {},
        },
      }
    }

    case `${actions.DELETE_USER_MFA_DEVICE}_PENDING`: {
      return {
        ...state,
        deleteMFADevice: {
          fetching: true,
          error: null,
        },
      }
    }

    case `${actions.DELETE_USER_MFA_DEVICE}_FULFILLED`: {
      return {
        ...state,
        deleteMFADevice: {
          fetching: false,
          error: null,
        },
      }
    }

    case `${actions.DELETE_USER_MFA_DEVICE}_REJECTED`: {
      return {
        ...state,
        deleteMFADevice: {
          fetching: false,
          error: 'Something went wrong while deleteing the registered MFA device.',
        },
      }
    }

    case `${actions.DELETE_ALL_USER_MFA_DEVICE}_PENDING`: {
      return {
        ...state,
        deleteAllMFADevice: {
          fetching: true,
          error: null,
        },
      }
    }

    case `${actions.DELETE_ALL_USER_MFA_DEVICE}_FULFILLED`: {
      return {
        ...state,
        deleteAllMFADevice: {
          fetching: false,
          error: null,
        },
      }
    }

    case `${actions.DELETE_ALL_USER_MFA_DEVICE}_REJECTED`: {
      return {
        ...state,
        deleteAllMFADevice: {
          fetching: false,
          error:
            'Something went wrong while deleteing all the registered MFA devices.',
        },
      }
    }

    case `${actions.INITIATE_WEB_AUTHN_AUTHENTICATION}_PENDING`: {
      return {
        ...state,
        initiateAuthentication: {
          fetching: true,
          error: null,
          data: {},
        },
      }
    }

    case `${actions.INITIATE_WEB_AUTHN_AUTHENTICATION}_FULFILLED`: {
      const data = get(action, 'payload.data', {})

      return {
        ...state,
        initiateAuthentication: {
          fetching: false,
          error: null,
          data,
        },
      }
    }

    case `${actions.INITIATE_WEB_AUTHN_AUTHENTICATION}_REJECTED`: {
      return {
        ...state,
        initiateAuthentication: {
          fetching: false,
          error: 'Unable to initiate webauthn.',
          data: {},
        },
      }
    }

    default:
      return { ...state }
  }
}
